import { useQuery } from '@tanstack/react-query';

export interface GenreCatalogItem {
  slug: string;
  name: string;
  category?: string;
  description?: string;
  icon_name?: string;
  gradient_from?: string;
  gradient_to?: string;
  featured: boolean;
  sort_order: number;
  is_active: boolean;
  count: number;
}

export function useGenresCatalog(params: { limit?: number; category?: string; featuredOnly?: boolean } = {}) {
  const { limit = 20, category, featuredOnly } = params;

  return useQuery<{ success: boolean; items: GenreCatalogItem[]; total: number; limit: number }, Error>({
    queryKey: ['genres-catalog', limit, category, featuredOnly],
    queryFn: async () => {
      const usp = new URLSearchParams();
      if (limit) usp.set('limit', String(limit));
      if (category) usp.set('category', category);
      if (featuredOnly !== undefined) usp.set('featuredOnly', String(featuredOnly));
      const res = await fetch(`/api/genres?${usp.toString()}`);
      if (!res.ok) throw new Error('Failed to load genres');
      return res.json();
    },
    staleTime: 60 * 1000,
    refetchOnWindowFocus: false
  });
}


